// client/src/pages/Register/Register.jsx
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Register.css";
import { COPY, useToast } from "../../context/ToastContext";

// The register endpoint answers 400 for all three of these, so status alone
// cannot tell them apart. Match on the server's message, but treat it purely as
// a lookup key. The text shown to the user always comes from this table.
const REGISTER_COPY = {
  "Invalid Student Worker ID": [
    "error",
    "That Worker ID isn't valid. Ask a student worker to enter it.",
  ],
  "Student with your ID already exists": [
    "warning",
    "You're already registered. Try signing in instead.",
  ],
  "Name, Student ID, and Worker ID are required": [
    "warning",
    "Please fill in every field before submitting.",
  ],
};

export default function Register() {
  const navigate = useNavigate();
  const { toast } = useToast();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [studentID, setStudentID] = useState("");
  const [workerID, setWorkerID] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    const payload = {
      name: `${firstName} ${lastName}`,
      studentID,
      workerID,
    };

    try {
      await axios.post(`/api/student?action=register`, payload, { withCredentials: true });

      toast.success("Registered! You're all set.");
      navigate("/landing");
    } catch (err) {
      console.error("Registration error:", err);

      if (!err.response) {
        toast.error(COPY.unreachable);
        return;
      }

      const known = REGISTER_COPY[err.response?.data?.message];
      if (known) {
        const [variant, message] = known;
        toast[variant](message);
      } else {
        toast.error(COPY.serverError);
      }
    }
  };

  return (
    <div className="register-page">
      <div className="register-container">
        <h1 className="register-title">Register</h1>
        <form onSubmit={submit}>
          <div className="input-group">
            <label htmlFor="FirstName">First Name</label>
            <input
              id="FirstName"
              autoComplete="off"
              type="text"
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="LastName">Last Name</label>
            <input
              id="LastName"
              autoComplete="off"
              type="text"
              placeholder="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="StudentID">Student ID</label>
            <input
              id="StudentID"
              type="text"
              autoComplete="off"
              placeholder="Student ID"
              value={studentID}
              onChange={(e) => setStudentID(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="WorkerID">Worker ID</label>
            <input
              id="WorkerID"
              type="password"
              autoComplete="off"
              placeholder="Worker ID"
              value={workerID}
              onChange={(e) => setWorkerID(e.target.value)}
              required
            />
          </div>

          <button className="submit-btn" type="submit">
            Register
          </button>
        </form>
        <div className="note-box">
          <p className="note-text">
            Note: The student fills out the first three fields, and the Student Worker fills out the last one.
          </p>
        </div>
      </div>
    </div>
  );
}
